import { getRoomAsyncResponse } from "./types";
import * as roomActions from "./rooms.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_ROOM, retrieveToken } from "../../../helpers/api";

export function* getRooms(action: ReturnType<typeof roomActions.getRoomAsync.request>) {
  try {
    const page = action.payload.page ? action.payload.page : 1;
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_ROOM.GET_ROOMS(page), token);
    if (result.status === 200) {
      const parsed: getRoomAsyncResponse = yield call(result.json.bind(result));
      yield put(roomActions.getRoomAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(roomActions.getRoomAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(roomActions.getRoomAsync.failure(parsed));
  }
}

export default function* roomsSagaGetRoom() {
  yield takeEvery(roomActions.getRoomAsync.request, getRooms);
}
